/**
 * Collection Hero Countdown Timer
 * Updates countdown timer and switches between variants based on remaining time
 */

(function() {

  function initCountdown() {
    const countdownWrapper = document.querySelector('.collection-hero__countdown-wrapper');

    if (!countdownWrapper) {
      console.warn('Countdown wrapper not found');
      return;
    }

    const targetDateStr = countdownWrapper.getAttribute('data-countdown-target');
    if (!targetDateStr) {
      console.warn('Countdown target date not found');
      return;
    }

    // Parse target date (format: YYYY-MM-DD HH:MM)
    const [datePart, timePart] = targetDateStr.split(' ');
    if (!datePart) {
      console.error('Invalid date format:', targetDateStr);
      return;
    }

    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart ? timePart.split(':') : ['23', '59'];

    const targetDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes) || 0, 0);

    // Validate date
    if (isNaN(targetDate.getTime())) {
      console.error('Invalid countdown target date:', targetDateStr);
      return;
    }

    // Get countdown elements
    const simpleVariant = countdownWrapper.querySelector('.collection-hero__countdown--simple');
    const badgesVariant = countdownWrapper.querySelector('.collection-hero__countdown--with-badges');
    const daysElements = countdownWrapper.querySelectorAll('.collection-hero__countdown-days');
    const hoursElements = countdownWrapper.querySelectorAll('.collection-hero__countdown-hours');

    if (!simpleVariant || !badgesVariant) {
      console.error('Countdown variants not found');
      return;
    }

    function updateCountdown() {
      const now = new Date();
      const timeLeft = targetDate - now;

      if (timeLeft <= 0) {
        // Timer expired - hide both variants
        simpleVariant.style.display = 'none';
        badgesVariant.style.display = 'none';
        return;
      }

      // Calculate days and hours
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      // Determine which variant to show (>3 days = simple, ≤3 days = with badges)
      const showBadgesVariant = days <= 3;

      if (showBadgesVariant) {
        // Show badges variant
        simpleVariant.style.display = 'none';
        badgesVariant.style.display = 'flex';
      } else {
        // Show simple variant
        simpleVariant.style.display = 'flex';
        badgesVariant.style.display = 'none';
      }

      // Update days and hours in all elements
      daysElements.forEach(function(el) {
        if (el) el.textContent = days;
      });

      hoursElements.forEach(function(el) {
        if (el) el.textContent = hours;
      });
    }

    // Initial update
    updateCountdown();

    // Update every hour (3600000 ms)
    setInterval(updateCountdown, 3600000);
  }

  // Wait for DOM to be ready - handle both immediate and deferred loading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    // DOM already loaded, run immediately
    initCountdown();
  }

  // Also try after a short delay in case script loads before section HTML
  setTimeout(initCountdown, 100);
})();

